import { render, staticRenderFns } from "./postWarningDetailProject.vue?vue&type=template&id=7bea6918&scoped=true&"
import script from "./postWarningDetailProject.vue?vue&type=script&lang=js&"
export * from "./postWarningDetailProject.vue?vue&type=script&lang=js&"
import style1 from "./postWarningDetailProject.vue?vue&type=style&index=1&id=7bea6918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea6918",
  null
  
)

export default component.exports